export default "__VITE_ASSET__B5Qm7l4I__"